export default __webpack_public_path__ + "4c0b873fb2bf56b80cd196de7742e09e.png";